import { JsonPartsRepository } from "../../repositories/implementations/JsonPartsRepository";
import { GetAllPartsUseCase } from "./GetAllPartsUseCase";

export const getAllPartsUseCase = new GetAllPartsUseCase(
    new JsonPartsRepository()
);